import {
  APP_INITIALIZER,
  DEFAULT_CURRENCY_CODE,
  EnvironmentProviders,
  FactoryProvider,
  Provider,
  importProvidersFrom,
} from '@angular/core';
import { Router } from '@angular/router';
import * as Sentry from '@sentry/angular-ivy';
import { MarkdownModule } from 'ngx-markdown';
import { CoreModule } from './core/core.module';
import { BADGE_SINK, NotificationSinkService } from './core/notifications';
import { ValidationModule } from './core/validation';
import { breezeValidationAdapaterProvider } from './core/validation/breeze-validation-adapter';
import { uniqueValidatorProviders } from './core/validation/unique.validator';
import { onlyOneSingleAppointmentTypeValidatorProvider } from './model/validation/only-one-single-appointment-type-validator';
import { validationMetadata } from './model/validation/validation-metadata';
import { TaskBadgeSink } from './modules/admin/apps/tasks/badge/task-badge-sink';
import { RegionVariantService } from './core/region-variant/region-variant.service';

export const provideDefaults = (): Array<Provider | EnvironmentProviders> => {
  return [
    {
      // This is only used as a fallback if the incorrect currency pipe is used, will not update
      provide: DEFAULT_CURRENCY_CODE,
      useFactory: (regionVariantService: RegionVariantService) => regionVariantService.getCurrencyCode(),
      deps: [RegionVariantService],
    },
  ];
};

export const provideSentry = (): Array<Provider | EnvironmentProviders> => {
  return [
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => {},
      deps: [Sentry.TraceService],
      multi: true,
    },
  ];
};

export const provideBadgeSinks = (): Array<FactoryProvider> => {
  return [
    {
      provide: BADGE_SINK,
      useFactory: (notificationSink: NotificationSinkService) => new TaskBadgeSink(notificationSink),
      deps: [NotificationSinkService],
      multi: true,
    },
  ];
};

export const provideMarkdown = (): EnvironmentProviders => {
  return importProvidersFrom(MarkdownModule.forRoot({}));
};

export const provideValidation = (): Array<Provider | EnvironmentProviders> => {
  return [
    importProvidersFrom(
      ValidationModule.forRoot({
        validationMetadata: validationMetadata,
      }),
    ),
    breezeValidationAdapaterProvider,
    ...uniqueValidatorProviders,
    onlyOneSingleAppointmentTypeValidatorProvider,
  ];
};

export const provideCore = (): EnvironmentProviders => {
  return importProvidersFrom(CoreModule);
};
